<template>
        <v-dialog :max-width="Modal.Confirmacao.larguraMaxima" persistent v-model="deveMostrarModalConfirmacaoAssinaturas">
            <v-card :min-width="Modal.Confirmacao.larguraMinima" :max-width="Modal.Confirmacao.larguraMaxima">
                <v-card-title class="primary modal-title" primary-title>
                    <span>Confirmar Assinaturas</span>
                    <v-btn flat depressed @click="fecharModalConfirmacaoAssinaturas">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    Um token de confirmação foi enviado no e-mail: <br/>
                    <span class="primary--text text--lighten-1"> {{value.email}}</span>
                </v-card-text>

                <v-card-text class="pb-0 az-form-content">
                    <v-text-field v-model="value.codigoConfirmacao"
                                :error-messages="errors.collect('Mensagem Token Confirmação')"
                                v-validate="'required'"
                                :name="'Mensagem Token Confirmação'"
                                label="Token de confirmação"
                                placeholder="Digite o token de confirmação"/>
                </v-card-text>

                <v-card-actions class="py-2 px-3">
                    <v-btn color="botao-cancelar-color" id="botaoCancelarAssinaturas" outline flat @click="fecharModalConfirmacaoAssinaturas">
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn id="botaoConfirmarAssinaturas" color="primary" depressed @click="lancarEventoconfirmaAssinaturas">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import { Modal } from '@/core/constants'

export default {
    name: 'ModalConfirmacaoAssinaturaEmLote',
    $_veeValidate: {
        validator: 'new'
    },
    props: ['deveMostrarModalConfirmacaoAssinaturas', 'value'],
    data() {
        return {
            Modal
        }
    },
    methods: {
        async lancarEventoconfirmaAssinaturas() {
            await this.validarPreenchimento()
            this.$emit('confirmaAssinaturas')
            this.limparCampos()
        },
        async validarPreenchimento() {
            const estaValidado = await this.$validator.validate('Mensagem Token Confirmação')
            if (!estaValidado) {
                throw new Error('Preencha o campo com o token recebido no email informado.')
            }
        },
        fecharModalConfirmacaoAssinaturas() {
            this.$emit('fecharModalConfirmacaoAssinaturas')
            this.limparCampos()
        },
        limparCampos() {
            this.$validator.reset()
        }
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base) !important
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important
</style>